import { Heading, HeadingProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const HomeHeading = ({ children, id, ...headingProps }: PropsWithChildren & HeadingProps) => (
  <section id={id}>
    <Heading fontSize="2xl" fontWeight="700" lineHeight="32px" mt={4} {...headingProps}>
      {children}
    </Heading>
  </section>
);
